<template>
  <div class="recruitStaffManage">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-activitiesManage">
          <div class="head-tab--nav">
            <div class="head-nav h-3 clearFloat">
              <span class="c-normal">{{
                $t("ListAllocationManagement.ba")
              }}</span>
            </div>
          </div>
          <div class="activitiesManage-container">
            <div class="content">
              <div class="flex-all Inquire-box mb10">
                <div class="flex-al">
                  <div class="ipt-box">
                    <el-input
                      clearable
                      :placeholder="$t('ListAllocationManagement.bb')"
                      class="input-cont"
                      style="width: 260px"
                      @clear="search"
                      v-model="selectForm.keyword"
                    ></el-input>
                  </div>
                  <el-button type="primary" class="btn-inquire" @click="search">
                    {{ $t("Crmactivemanage.as") }}
                  </el-button>
                </div>

                <div class="flex-al color-blue cursor-pointer">
                  <span class="el-icon-setting mr5"></span>
                  <el-button
                    type="text"
                    size="small"
                    @click="handleManageStaff"
                  >
                    <span class="fs14">管理招生人员</span>
                  </el-button>
                </div>
              </div>
              <div class="tableList" ref="auto_height_table">
                <normalTableCont ref="multipleTable" :tableData="tableList">
                  <el-table-column
                    ref="fixedColumn"
                    label="操作"
                    align="center"
                    width="150px"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="small"
                        @click.native.prevent="onClickHand(scope.row)"
                        >{{ $t("ListAllocationManagement.bc") }}</el-button
                      >
                    </template>
                  </el-table-column>
                </normalTableCont>
              </div>
              <el-pagination
                style="margin-top: 35px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataNumber"
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-main>
      <el-dialog
        :title="$t('ListAllocationManagement.mdfp')"
        :visible.sync="dialogVisible"
        class="tan-binding"
        width="520px"
        :before-close="handleClose"
      >
        <div class="create">
          <el-form
            label-width="150px"
            style="padding: 0px"
            ref="form"
            :model="form"
          >
            <el-form-item
              label="校外招交接人："
              prop="tomarketer_id"
              :rules="[
                {
                  required: true,
                  message: $t('ListAllocationManagement.be'),
                },
              ]"
            >
              <el-select
                filterable
                clearable
                v-model="form.tomarketer_id"
                style="width: 280px"
                :placeholder="$t('ListAllocationManagement.be')"
                @change="form.to_fu_marketer_id = []"
              >
                <el-option
                  v-for="item in personList"
                  :key="item.marketer_id"
                  :label="item.marketer_name"
                  :value="item.marketer_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="校内招交接人："
              prop="inmarketer_id"
              :rules="[
                {
                  required: true,
                  message: $t('ListAllocationManagement.bf'),
                },
              ]"
            >
              <el-select
                filterable
                clearable
                v-model="form.inmarketer_id"
                style="width: 280px"
                :placeholder="$t('ListAllocationManagement.bf')"
                @change="form.in_fu_marketer_id = []"
              >
                <el-option
                  v-for="item in personList"
                  :key="item.marketer_id"
                  :label="item.marketer_name"
                  :value="item.marketer_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="校外招副负责人："
              prop="to_fu_marketer_id"
            >
              <el-select
                multiple
                collapse-tags
                filterable
                clearable
                v-model="form.to_fu_marketer_id"
                style="width: 280px"
                placeholder="请选择校外招副负责人"
              >
                <el-option
                  v-for="item in outFuPersonList"
                  :key="item.marketer_id"
                  :label="item.marketer_name"
                  :value="item.marketer_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="校内招副负责人："
              prop="in_fu_marketer_id"
            >
              <el-select
                multiple
                collapse-tags
                filterable
                clearable
                v-model="form.in_fu_marketer_id"
                style="width: 280px"
                placeholder="请选择校内招副负责人"
              >
                <el-option
                  v-for="item in inFuPersonList"
                  :key="item.marketer_id"
                  :label="item.marketer_name"
                  :value="item.marketer_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="onClickConfirm">{{
            $t("ListAllocationManagement.bg")
          }}</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </span>
      </el-dialog>
    </PageNav>

    <SliderBox
      :showSliderBox="showSliderBox"
      @hideSliderBox="hideSliderBox"
      sliderWidth="700px"
    >
      <div class="silder-contain">
        <div class="slider-top clearFloat">
          <p class="h3 slider-title pull-left">管理招生人员</p>
          <div class="pull-right h1 btn-close font-gray" @click="hideSliderBox">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="pAll20">
          <div class="flex-al mb10">
            <el-select
              placeholder="是否负责跟进"
              v-model="form.isfollowup"
              @change="getMarketerFn"
              size="small"
              style="width: 180px"
              class="mr10"
            >
              <el-option label="全部" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="2"></el-option>
            </el-select>

            <el-input
              placeholder="请输入姓名"
              v-model="form.keyword"
              style="width: 180px"
              class="mr10"
              size="small"
              clearable
              @clear="getMarketerFn"
            ></el-input>

            <el-button type="primary" size="small" @click="getMarketerFn">
              搜索
            </el-button>
          </div>
          <p class="color-orange mb10">
            注:在分配名单时仅出现负责招生跟进的人员
          </p>
          <div ref="staff_height_table">
            <normalTableCont :tableData="staffTableList">
              <el-table-column
                ref="fixedColumn"
                label="是否负责招生跟进"
                align="center"
                width="200px"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-switch
                    @change="switchChange(scope)"
                    active-value="1"
                    inactive-value="2"
                    active-color="#20a8d8"
                    v-model="scope.row.isfollowup"
                  ></el-switch>
                </template>
              </el-table-column>
            </normalTableCont>
          </div>
        </div>
      </div>
    </SliderBox>
  </div>
</template>

<script>
import PageNav from "../../components/Nav/nav.vue";
import CrmActiveManage from "@/views/Admissioncue/admissionCue.js";
import normalTableCont from "../../components/tables/switchTableCont.vue";
import SliderBox from "@/components/SliderBox";
export default {
  name: "Activitiesmanage-activitiesManage",
  data() {
    return {
      showSliderBox: false,
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      currentPage: 1,
      openMenu: ["1"],

      //筛选条件
      selectForm: {
        keyword: "",
      },
      form: {
        tomarketer_id: "",
        inmarketer_id: "",
        to_fu_marketer_id: [],
        in_fu_marketer_id: [],

        isfollowup: "0",
        keyword: "",
      },
      tableList: {
        list: [],
        columns: [],
        options: {
          mutiSelect: false,
          tableHeight: null, //表格高度
          errortip: "",
          issetting: false,
        },
      },
      staffTableList: {
        list: [],
        columns: [
          {
            custom: 1,
            fieldname: "staffer_cnname",
            fieldstring: "中文名",
            show: 1,
          },
          {
            custom: 1,
            fieldname: "staffer_enname",
            fieldstring: "英文名",
            show: 1,
          },
        ],
        options: {
          mutiSelect: false,
          tableHeight: null, //表格高度
          errortip: "",
          issetting: false,
        },
      },
      dialogVisible: false,
      personList: [],
      frommarketerId: "",
    };
  },
  computed: {
    // 校外招副负责人列表：排除校外招交接人已选的人
    outFuPersonList() {
      return this.personList.filter(
        (item) => item.marketer_id !== this.form.tomarketer_id
      );
    },
    // 校内招副负责人列表：排除校内招交接人已选的人
    inFuPersonList() {
      return this.personList.filter(
        (item) => item.marketer_id !== this.form.inmarketer_id
      );
    },
  },
  components: {
    PageNav,
    normalTableCont,
    SliderBox,
  },

  created() {
    this.slider = this.$store.state.Slider;
    this.getfiterChief();
    this.Home(this.pagenum);
  },
  methods: {
    switchChange(v) {
      this.$http.setMarketerFollowupOne({
        ed_marketer_id: v.row.marketer_id,
        isopen: v.row.isfollowup,
      }).then((res) =>{
        const { code, msg } = res.data;
        this.$message({
          message: msg,
          type: code === 200 ? "success" : "error",
        });
        this.getMarketerFn();
      })
    },
    getMarketerFn() {
      return new Promise((resolve) => {
        this.$http
          .getMarketer({
            isfollowup: this.form.isfollowup,
            keyword: this.form.keyword,
          })
          .then((res) => {
            const { code, msg, data: body } = res.data;
            this.staffTableList.list = code === 200 ? body.list : [];
            this.staffTableList.options.errortip = msg;
            resolve();
          });
      });
    },
    handleManageStaff() {
      this.getMarketerFn().then(() => {
        this.showSliderBox = true;
        this.$nextTick(() => {
          if (this.$refs["staff_height_table"]) {
            this.staffTableList.options.tableHeight =
              this.$Common.getTableHeight(
                this.$refs.staff_height_table.getBoundingClientRect().top + 90
              );
          }
        });
      });
    },
    hideSliderBox() {
      this.showSliderBox = false;
    },
    Home() {
      CrmActiveManage.getRecruiter({
        keyword: this.selectForm.keyword,
        p: this.currentPage,
        num: this.pagesize,
        is_count: "1", // 是否需要总数
      }).then((res) => {
        let columns = res.data.data.field;
        this.tableList.columns = columns;
        this.dataNumber = parseInt(res.data.data.allnum);
        if (res.data.code === 200) {
          this.tableList.list = res.data.data.list;
        } else {
          this.tableList.list = [];
          this.tableList.options.errortip = res.data.msg;
        }
      });
    },
    onClickHand(v) {
      this.frommarketerId = v.marketer_id;
      this.getfiterChief();
      this.resetForm();
      this.dialogVisible = true;
    },
    resetForm() {
      this.form = {
        tomarketer_id: "",
        inmarketer_id: "",
        to_fu_marketer_id: [],
        in_fu_marketer_id: [],
      };

      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    onClickConfirm() {
      this.$refs.form.validate((val) => {
        if (val) {
          CrmActiveManage.migrationCrmApi({
            frommarketer_id: this.frommarketerId,
            tomarketer_id: this.form.tomarketer_id,
            inmarketer_id: this.form.inmarketer_id,
            to_fu_marketer_id: this.form.to_fu_marketer_id.join(','),
            in_fu_marketer_id: this.form.in_fu_marketer_id.join(','),
            marketer_id: this.$store.state.MARKETER_ID,
          }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.dialogVisible = false;
              this.Home();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    getfiterChief() {
      CrmActiveManage.getMarketer({
        main_marketer_id: this.frommarketerId,
      }).then((res) => {
        this.personList = res.data.data.list;
        // this.chiefPerson.unshift(
        //   {
        //     marketer_id: "", marketer_name: "不限"
        //   })
      });
    },
    handleClose(done) {
      done();
    },
    search() {
      this.currentPage = 1;
      this.Home(this.pagenum);
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.Home(this.pagenum);
    },
    handleCurrentChange(val) {
      (() => {})(`当前页: ${val}`);
      this.currentPage = val;
      this.Home(val);
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.tableList.options.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 90
        );
      }
    });
  },
};
</script>

<style lang="less">
@import url("../../assets/less/manage.less");
@import url("../CampusEnrollment/admissionCue.less");
</style>
